<ngx-ui-loader [loaderId]="'loader-03'"></ngx-ui-loader>
<div>
  <div>
    <div
      class="alert alert-light"
      role="alert"
      style="color: red; text-align: center; font-weight: bold"
      *ngIf="sourceselect"
      @fade
    >
      IF FUNDING FOR THIS CONTRACT IS PROCESSED THROUGH YOUR OFFICE PLEASE
      SUBMIT AS AN ADDITIONAL PURCHASE TRANSACTION
    </div>
    <!-- <div
      class="alert alert-light"
      role="alert"
      style="color: red; text-align: center; font-weight: bold"
      *ngIf="sourceselecttransfer"
    >
      PLEASE PROVIDE DETAILS IN THE DETAILS BELOW
    </div> -->
    <div
      class="alert alert-light"
      role="alert"
      style="color: red; text-align: center; font-weight: bold"
      *ngIf="editsource"
    >
      Warning: If Product Type or Source of Funds are changed you will lose data
      previously entered. Review data will also be lost once you hit continue.
    </div>
    <div
      class="alert alert-light"
      role="alert"
      style="color: red; text-align: center; font-weight: bold"
      *ngIf="osjValid"
    >
      Warning: Submit check transactions between 5:00 a.m. - 12:00 p.m. (noon)
      EST.     To submit a check transaction outside this time window, please
      contact the home office.
    </div>
    <div
      class="alert alert-light"
      role="alert"
      style="color: red; text-align: center; font-weight: bold"
      *ngIf="checkWarningShowmsg"
    >
      Warning: You have missed the daily deadline for check transactions. Please
      contact the home office immediately to discuss your options.
    </div>

   <!--  <div class="flex items-center justify-center">
      <span class="p-4 border rounded-lg">
        Questions or comments? Insurance:
        <a
          href="mailto:cia@capital-invest.com"
          class="text-blue-500 hover:underline"
        >
          cia&#64;capital-invest.com
        </a>
        <span class="mx-2">|</span>
        Trading:
        <a
          href="mailto:CICTrading@capital-invest.com"
          class="text-blue-500 hover:underline"
        >
          CICTrading&#64;capital-invest.com
        </a>
      </span>
    </div> -->
  </div>
  <!--  <div class="card-col" style="float: right; margin-right: 10px" *ngIf="!showTopRow">
    <div class="p-6 my-4 shadow card rounded-2xl">

      <div class="p-6 my-4 shadow card rounded-2xl">
        <button size="tiny" type="button" (click)="toggleShowTopRow()">
          Show top
        </button>
      
    </div>
  </div> -->
  <!--   @if (!showTopRow) { -->
  <form
    [formGroup]="firstForm"
    (ngSubmit)="onFirstSubmit()"
    [ngClass]="{ hidden: !showTopRow }"
  >
    <div class="flex flex-wrap gap-4 card-row">
      <!-- Client Information -->
      <div class="ml-2 card-col">
        <div
          class="card dark:bg-gray-800 rounded-2xl shadow p-6 my-4 h-[25.5rem] w-[35em] overflow-hidden"
          @fade
        >
          <div
            class="mb-4 text-lg font-bold text-gray-900 card-title dark:text-gray-100"
          >
            Client Information
          </div>

          @if (RepExists) {
          <div class="mb-3 spacing">
            <label
              class="flex items-center text-gray-800 tiny dark:text-gray-200"
            >
              <kendo-icon name="user"></kendo-icon>&nbsp;Rep:
            </label>
            <kendo-combobox
              #combo
              class="w-[350px] mt-1"
              [suggest]="true"
              (focus)="onFocus(combo)"
              [virtual]="virtual"
              [loading]="false"
              (selectionChange)="selectionChange($event)"
              formControlName="RepId"
              [kendoDropDownFilter]="filterSettings"
              [valuePrimitive]="true"
              [data]="clientlistItems"
              textField="fullName"
              valueField="repId"
              placeholder="Select Rep..."
              required
            >
            </kendo-combobox>
          </div>
          }

          <div class="mb-3 spacing">
            <label class="text-gray-800 tiny dark:text-gray-200">
              <kendo-icon name="file-text"></kendo-icon>&nbsp;Rep Code:
            </label>
            <kendo-dropdownlist
              required
              #repsel
              formControlName="repCodeId"
              (selectionChange)="selectionChangeRepCode($event)"
              [valuePrimitive]="true"
              [virtual]="virtual"
              [loading]="loaderCode"
              [data]="repcodelistItems"
              textField="repCode"
              valueField="repCodeId"
              class="w-[350px] mt-1"
            >
            </kendo-dropdownlist>
          </div>

          <div class="mb-3 spacing">
            <label class="text-gray-800 tiny dark:text-gray-200">
              &nbsp;<ng-icon name="heroExclamationCircle"></ng-icon
              >&nbsp;&nbsp;&nbsp;Client:
            </label>
            <kendo-dropdownlist
              required
              #drop
              formControlName="clientTax"
              (valueChange)="handleFilter()"
              (selectionChange)="selectionChangeClient($event)"
              [valuePrimitive]="true"
              name="ourrep"
              [virtual]="virtual"
              [loading]="loaderTypeClient"
              [data]="clientthirdlisting"
              textField="firstName"
              valueField="clientId"
              class="w-[350px] mt-1"
            >
            </kendo-dropdownlist>
          </div>

          <div
            *ngIf="repwasterminated"
            class="font-semibold text-red-500 novalue"
          >
            * Rep is no longer available, Please select a new rep.
          </div>
        </div>
      </div>

      <!-- Product and Transaction Information -->
      <div class="card-col">
        <div
          class="card dark:bg-gray-800 rounded-2xl shadow p-6 my-4 h-[25.5rem]"
          @fade
        >
          <div
            class="mb-4 text-lg font-bold text-gray-900 card-title dark:text-gray-100"
          >
            Product and Transaction Information
          </div>

          <div class="flex items-center mb-3 spacing">
            <label
              class="text-gray-800 tiny dark:text-gray-200 whitespace-nowrap"
            >
              <ng-icon name="heroExclamationCircle"></ng-icon>&nbsp;Product
              Type:
            </label>
            <kendo-dropdownlist
              (selectionChange)="selectionChangeProductTypes($event)"
              (valueChange)="handleFilter()"
              #drop
              formControlName="productTypeId"
              [valuePrimitive]="true"
              [virtual]="virtual"
              [loading]="false"
              [data]="productlisting"
              textField="productTypeDesc2"
              valueField="productTypeId"
              class="w-[250px] ml-6"
            >
            </kendo-dropdownlist>
          </div>

          <div class="flex items-center mb-3 spacing">
            <label
              class="text-gray-800 tiny dark:text-gray-200 whitespace-nowrap"
            >
              <ng-icon name="heroExclamationCircle"></ng-icon>&nbsp;Transaction
              Type:
            </label>
            <kendo-dropdownlist
              (selectionChange)="selectionChangetypes($event)"
              #drop
              formControlName="transact"
              [valuePrimitive]="true"
              [virtual]="virtual"
              [loading]="loadetrans"
              [data]="translisting"
              textField="transactionTypeDesc"
              valueField="transactionTypeId"
              (valueChange)="handleFilter()"
              class="w-[250px] ml-6"
            >
            </kendo-dropdownlist>
          </div>

          <div class="flex justify-end pr-2 mt-4">
            <button
              *ngIf="accountformTrue"
              class="btn btn-primary k-button k-button-solid k-rounded-md"
              type="button"
              [disabled]="!firstForm.get('repCodeId').value"
              (click)="cpSubmit()"
            >
              Continue
            </button>
          </div>
        </div>

        <!-- Source of Funds -->
        <div
          class="p-6 my-4 shadow card dark:bg-gray-800 rounded-2xl"
          *ngIf="source"
        >
          <div
            class="mb-4 text-lg font-bold text-gray-900 card-title dark:text-gray-100"
          >
            Source of the funds for the purchase
          </div>

          <!-- Replace nebular radio buttons -->
          <div class="spacing">
            <div
              *ngFor="let option of sourceFundtypelist"
              class="flex items-center mb-2"
            >
              <input
                type="radio"
                [value]="option.sourceOfFundsTypeId"
                formControlName="sourcetypes"
                (change)="sourceCheckTimeSelect(option.sourceOfFundsTypeDesc)"
                class="mr-2 accent-blue-600"
              />
              <label class="text-gray-800 dark:text-gray-200">{{
                option.sourceOfFundsTypeDesc
              }}</label>
            </div>
          </div>

          <!-- Bottom buttons -->
          <div class="flex gap-3 mt-4">
            <button
              *ngIf="showTopRow"
              class="btn btn-secondary k-button k-rounded-md"
              type="button"
              (click)="toggleShowTopRow()"
            >
              Hide top
            </button>
            <button
              *ngIf="continuechanges"
              class="btn btn-primary k-button k-rounded-md"
              [disabled]="!firstForm.valid"
              type="button"
              (click)="continueCge()"
            >
              Continue
            </button>
            <button
              *ngIf="continuechanges"
              class="btn btn-light k-button k-rounded-md"
              [disabled]="!firstForm.valid"
              type="button"
              (click)="continuecancel()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div>
    <!-- <p class="text-sm text-gray-700">
  Form valid: {{ firstForm.valid }}
</p>
<p class="text-sm text-gray-700">
  Form invalid: {{ firstForm.invalid }} + {{checkWarning}}
</p> -->
    @if (firstForm.valid && checkWarning === false && reloadStep2) {
    <div style="margin-left: 10px">
      <div class="card-row">
        <div class="card-col">
          <div
            class="p-6 my-4 shadow card rounded-2xl"
            style="
              height: 100%;
              width: 100%;
              min-width: 1030px;
              overflow: hidden;
            "
          >
            <div class="p-6 my-4 shadow card bg-light rounded-2xl">
              <gd-step2form
                style="line-height: 15px"
                [RepSelected]="RepSelected"
                [clientId]="clientId"
                [ClientSelected]="ClientSelected"
                [productTypeSelected]="productTypeSelected"
                [transactionTypeSelected]="transactionTypeSelected"
                [SourceofFundsSelected]="SourceofFundsSelected"
                [RepCodeSelected]="RepCodeSelected"
                [repNamestring]="repNamestring"
                [repCodestring]="repCodestring"
                [Clientstring]="Clientstring"
                [productTypestring]="productTypestring"
                [stateof]="stateof"
                [transactionTypestring]="transactionTypestring"
                [sourceoffundsstring]="sourceoffundsstring"
                [clientthirdlisting]="clientthirdlisting"
                [taxen]="taxen"
                [InvObjectiveId]="InvObjectiveId"
                [LiquidityNeedsId]="LiquidityNeedsId"
                [InvestmentTimeHorizonId]="InvestmentTimeHorizonId"
                [InvestmentProfileId]="InvestmentProfileId"
                [AnnualIncFrom]="AnnualIncFrom"
                [AnnualIncTo]="AnnualIncTo"
                [NetWorthFrom]="NetWorthFrom"
                [NetWorthTo]="NetWorthTo"
                [LiquidNWFrom]="LiquidNWFrom"
                [loading]="loading"
                [loadingDelete]="loadingDelete"
                [LiquidNWTo]="LiquidNWTo"
                [InvestDescription]="InvestDescription"
                [statusTypeId]="StatusTypeId"
                [InvestmentTimeHorizonDescription]="
                  InvestmentTimeHorizonDescription
                "
                [ProfileDescription]="ProfileDescription"
                [LiquidDescription]="LiquidDescription"
                [dob]="$any(dob)"
                [Email]="Email"
                (submitEvent)="onSecondSubmit($event)"
              >
              </gd-step2form>
              <!-- <kendo-dialog title="Please confirm2" *ngIf="opened" (close)="close('cancel')" [minWidth]="250"
                [width]="450">
                <p style="margin: 30px; text-align: center">
                  Are you sure you want to continue?
                </p>
                <kendo-dialog-actions>
                  <button kendoButton (click)="close('no')">No</button>
                  <button kendoButton (click)="continue()" themeColor="primary">
                    Yes
                  </button>
                </kendo-dialog-actions>
              </kendo-dialog> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>
